enum MaskEnum {
  date = '99/99/9999',
  cep = '99999-999',
  cnpj = '99.999.999/9999-99',
  cpf = '999.999.999-99',
}

export default MaskEnum
